// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-indicator.MuiCircularProgress-colorPrimary{
    color: var(--app-fill-color-primary-one);
}
`, "",{"version":3,"sources":["webpack://./src/core/components/LoadingIndicator/styles/LoadingIndicator.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C","sourcesContent":[".loading-indicator.MuiCircularProgress-colorPrimary{\n    color: var(--app-fill-color-primary-one);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
